module.exports = __webpack_public_path__ + "static/media/paraco_genta.9be54337.png";